import React, {useEffect, useRef, useState} from 'react';
import {FieldProp} from '../types';

type UserInfoProps = {
    displayName: string;
    email: string;
    title: string;
    department: string;
    profilePhoto: string;
};

export const UserInfo: React.FunctionComponent<UserInfoProps> = ({
                                                                     displayName,
                                                                     email,
                                                                     title,
                                                                     department,
                                                                     profilePhoto,
                                                                 }): JSX.Element => {
        const [showDetailPanel, setShowDetailPanel] = useState<boolean>(false);
        const panelContainerRef = useRef<HTMLDivElement>(null);

        useEffect(() => {
            function handleClickOutside(event: MouseEvent) {
                // @ts-ignore
                if (panelContainerRef?.current && !panelContainerRef.current.contains(event.target)) {
                    setShowDetailPanel(false);
                }
            }

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [panelContainerRef]);

        return (
            <div style={{
                position: 'relative'
            }}
            >
                <div className="d-flex align-items-center"
                     style={{
                         cursor: 'pointer'
                     }}
                     onClick={() => setShowDetailPanel(true)}>
                    <img src={profilePhoto}
                         className="img-thumbnail rounded-circle p-0"
                         alt="Profile Photo"
                         style={{width: '30px', height: '30px'}}
                    />
                    <div className="flex-grow-1 ml-2">
                        <strong className="d-block" style={{lineHeight: 1}}>{displayName}</strong>
                        <small className="d-block text-muted" style={{lineHeight: 1}}>{email}</small>
                    </div>
                </div>

                {showDetailPanel &&
                <div
                    ref={panelContainerRef}
                    style={{
                        position: 'absolute',
                        top: '-100px',
                        left: '75px',
                        border: '1px solid #ccc',
                        boxShadow: '5px 5px 10px #999',
                        width: '300px',
                        background: 'white',
                        padding: '.75rem',
                        zIndex: 1
                    }}>
                    <div className={'d-flex align-items-center'}>
                        {profilePhoto &&
                        <img src={profilePhoto}
                             className="img-thumbnail rounded-circle"
                             alt="Profile Photo"
                             style={{
                                 width: '100px',
                                 height: '100px'
                             }}
                        />
                        }
                        <div className="ml-2">
                            <strong className="d-block">{displayName}</strong>
                            <small className="d-block text-muted">{email}</small>
                            <small className="d-block text-muted">{title}</small>
                            <small className="d-block text-muted">{department}</small>
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }
;